/* global document, console, $, jQuery */

/**
 * Tree sortable jQuery library using jQuery UI sortable.
 *
 * @package TreeSortable
 * @license MIT
 * @author Sajeeb Ahamed <sajeeb07ahamed@gmail.com>
 */

import { createWorksheet } from "../taskpane.js";
import { deleteWorksheetById } from "../taskpane.js";
import { isWorksheetEmpty } from "../taskpane.js";
import { getWorkbookMeta } from "../taskpane.js";
import { showMessage, resolveMessage } from "../taskpane.js";
import { data } from "../taskpane.js";
import { CONFIG } from "../taskpane.js";

import "jquery-ui/ui/widgets/sortable";
import "jquery-ui/themes/base/core.css";

const getCenterPosition = (element) => {
  const { top, left, width, height } = element.getBoundingClientRect();

  return {
    x: left + width / 2,
    y: top + height / 2,
  };
};

const getDistance = (elementA, elementB) => {
  const positionA = getCenterPosition(elementA);
  const positionB = getCenterPosition(elementB);

  const distanceX = Math.floor(Math.abs(positionA.x - positionB.x));
  const distanceY = Math.floor(Math.abs(positionA.y - positionB.y));

  return { distanceX, distanceY };
};

export function TreeSortable(options) {
  this.cssVarPrefix = "tree-sortable";
  this.defaults = {
    depth: 15,
    treeSelector: "#tree",
    branchSelector: ".tree-branch",
    branchPathSelector: ".branch-path",
    dragHandlerSelector: ".branch-drag-handler",
    placeholderName: "sortable-placeholder",
    childrenBusSelector: ".children-bus",
    levelPrefix: "branch-level",
    maxLevel: 10,
    dataAttributes: {
      id: "id",
      parent: "parent",
      level: "level",
      position: "position",
    },
  };

  this.options = { ...this.defaults, ...options };

  const self = this;

  this.run = function (disabled) {
    console.log("settings disabled", disabled);
    this.jQuerySupplements();
    this.initSorting(disabled);
    this.addCSSVars();
    this.branchesLeftShifting();
  };

  this.addCSSVars = function () {
    const variables = {
      depth: { value: self.options.depth, unit: "px" },
    };

    const root = $(self.options.treeSelector);

    for (const name in variables) {
      const value = variables[name];
      root.get(0).style.setProperty(`--${self.cssVarPrefix}-${name}`, `${value.value}${value.unit || ""}`);
    }
  };

  this.addBranchLeftShift = function ($element) {
    const { depth } = self.options;
    const level = Number($element.data("level")) || 1;
    $element.get(0).style.setProperty(`--${self.cssVarPrefix}-branch-left-shift`, `${depth * (level - 1)}px`);
    $element.get(0).style.setProperty(`--${self.cssVarPrefix}-children-left-shift`, `-${depth * (level - 1)}px`);
  };

  this.branchesLeftShifting = function () {
    const $elements = $(`${self.options.treeSelector} ${self.options.branchSelector}`);
    $elements.each(function () {
      self.addBranchLeftShift($(this));
    });
  };

  this.cleanSelector = function (selector) {
    // eslint-disable-next-line no-useless-escape
    return selector.replace(/^[\.#]/g, "");
  };

  this.getInstance = function () {
    return this;
  };

  this.getTreeEdge = function () {
    return $(this.options.treeSelector).offset().left;
  };
  this.pxToNumber = function (str) {
    return new RegExp("px$", "i").test(str) ? str.slice(0, -2) * 1 : 0;
  };
  this.numberToPx = function (num) {
    return `${num}px`;
  };
  this.onSortCompleted = function (callback) {
    $(this.options.treeSelector).on("sortCompleted", callback);
  };

  this.generateUUID = function () {
    return "xxxxx".replace(/[xy]/g, function (c) {
      var r = (Math.random() * 16) | 0,
        v = c == "x" ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  };
  this.createBranch = function (item, data) {
    console.log("createBranch", item, data);

    const {
      branchSelector,
      branchPathSelector,
      dragHandlerSelector,
      childrenBusSelector,
      levelPrefix,
      dataAttributes: {
        id: idAttr,
        parent: parentAttr,
        level: levelAttr,
        position: positionAttr,
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        visibility: visibleAttr,
      },
    } = self.options;

    /*
    const shouldBeVisible = (itemId, items) => {
      console.log("shouldBeVisible")
      const childrenMap = items.reduce((map, item) => {
        (map[item.parent_id] = map[item.parent_id] || []).push(item);
        return map;
      }, {});
      const hasVisibleDescendants = (id) => {
        console.log("hasVisibleDescendants")
        const item = items.find((i) => i.id === id);
        const children = childrenMap[id] || [];
        return item.visibility === "Visible" || children.some((child) => hasVisibleDescendants(child.id));
      };
      return hasVisibleDescendants(itemId);
    };
    */

    const hasViableDescendants = (elements, id) => {
      const elementMap = {};
      const childrenMap = {};

      // Build lookup tables for elements and parent-child relationships
      elements.forEach((el) => {
        elementMap[el.id] = el;
        if (el.parent_id !== null) {
          (childrenMap[el.parent_id] ||= []).push(el.id);
        }
      });

      // Recursive function to check for viable descendants
      const checkDescendants = (currentId) => {
        const currentElement = elementMap[currentId];
        if (!currentElement) return false;
        if (currentElement.visibility === "Visible" || currentElement.visibility === "") return true;
        return (childrenMap[currentId] || []).some(checkDescendants);
      };

      return checkDescendants(id);
    };

    if (typeof data != "undefined") {
      let vis = hasViableDescendants(data, item.id);
      //console.log("createBranch shouldBeVisible(", item.id, data, ")", vis);

      if (item.visibility == "Hidden" && !vis) {
        item.visibility = "hidden ";
      } else if (item.visibility == "Hidden" && vis) {
        item.visibility = "locked ";
      } else {
        item.visibility = "";
      }
    } else {
      item.visibility = "";
    }

    let getLuminance = (tabColor) => {
      tabColor = tabColor.replace(/^#/, "");
      let [red, green, blue] = [0, 2, 4].map((i) => parseInt(tabColor.substring(i, i + 2), 16));
      return (red * 0.299 + green * 0.587 + blue * 0.114) / 255;
    };

    let backgroundColor = "#FFFFFF";
    let invert = "";

    if (CONFIG.colorfulTabs.value) {
      backgroundColor = item.tabColor ? item.tabColor : "#FFFFFF";
      invert = getLuminance(backgroundColor) > 0.5 || !backgroundColor ? "" : "invert";
    }
    return `
		<li class="${invert} ${item.visibility}${self.cleanSelector(
      branchSelector
    )} ${levelPrefix}-${item.level}" data-${idAttr}="${item.id}" data-${parentAttr}="${item.parent_id}" data-${levelAttr}="${item.level}" data-${positionAttr}="${item.position}">
            <div class="contents">
                <span class="${self.cleanSelector(branchPathSelector)}"></span>
                <div class="branch-wrapper" style="background-color: ${backgroundColor}">
                    <div class="left-sidebar ${self.cleanSelector(dragHandlerSelector)}">
                        <div class="">
                            <i class="fa-solid fa-up-down-left-right"></i>
                            <i class="fa-solid fa-eye-low-vision"></i>
                        </div>
                        <span class="branch-title">${item.name}</span>
                    </div>
                    <div class="right-sidebar">
                        <button type="button" class="button add-child" data-tippy-content="Add a new child">
                            <i class="fa-solid fa-circle-plus"></i>
                        </button>
                        <button type="button" class="button add-sibling" data-tippy-content="Add a new sibling">
                            <i class="fa-solid fa-square-plus"></i>
                        </button>
                        <button type="button" class="button remove-branch" data-tippy-content="Remove Branch">
                            <i class="fa-solid fa-trash"></i>
                        </button>
                    </div>
                </div>
            </div>
            <div class="${self.cleanSelector(childrenBusSelector)}"></div>
		</li>
	`;
  };

  this.addListener = function (event, selector, callback) {
    $(document).on(event, `${self.options.treeSelector} ${selector}`, function (e) {
      callback(e, self);
    });
  };

  this.jQuerySupplements = function () {
    const { levelPrefix, dataAttributes } = self.options;

    $.fn.extend({
      getBranchLevel() {
        return Number($(this).data("level")) || 0;
      },
      updateBranchLevel(current, prev = null) {
        return this.each(function () {
          prev = prev || $(this).getBranchLevel() || 1;
          $(this)
            .removeClass(levelPrefix + "-" + prev)
            .addClass(levelPrefix + "-" + current)
            .data(dataAttributes.level, current)
            .attr(`data-${dataAttributes.level}`, current);

          self.addBranchLeftShift($(this));
        });
      },
      shiftBranchLevel(dx) {
        return this.each(function () {
          let level = $(this).getBranchLevel() || 1,
            newLevel = level + dx;
          $(this)
            .removeClass(levelPrefix + "-" + level)
            .addClass(levelPrefix + "-" + newLevel)
            .data(dataAttributes.level, newLevel)
            .attr(`data-${dataAttributes.level}`, newLevel);

          self.addBranchLeftShift($(this));
        });
      },
      getParent() {
        const { branchSelector } = self.options;
        const level = $(this).getBranchLevel() || 1;
        let $prev = $(this).prev(branchSelector);

        while ($prev.length) {
          // Only consider the candidate if it's at a lower level and not hidden.
          if ($prev.getBranchLevel() < level && !$prev.hasClass("hidden")) {
            return $prev;
          }
          // Otherwise, move to the previous sibling and repeat.
          $prev = $prev.prev(branchSelector);
        }

        return $prev;
      },
      getRootChild() {
        console.log("getrootchild");
        const { branchSelector, treeSelector, levelPrefix } = self.options;

        return $(treeSelector).children(`${branchSelector}.${levelPrefix}-1`);
      },
      getLastChild() {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { branchSelector, treeSelector, levelPrefix } = self.options;
        const $children = $(this).getChildren();
        const $descendants = $(this).getDescendants();
        // eslint-disable-next-line office-addins/call-sync-before-read
        const $lastChild = $descendants.length > $children.length ? $descendants.last() : $children.last();

        return $lastChild.length ? $lastChild : $();
      },
      getChildren() {
        const { branchSelector } = self.options;
        let $children = $();

        this.each(function () {
          let level = $(this).getBranchLevel() || 1,
            $next = $(this).next(branchSelector);

          while ($next.length && $next.getBranchLevel() > level) {
            if ($next.getBranchLevel() === level + 1) {
              $children = $children.add($next);
            }
            $next = $next.next(branchSelector);
          }
        });

        return $children;
      },
      getDescendants() {
        const { branchSelector } = self.options;
        let $descendants = $();

        this.each(function () {
          let level = $(this).getBranchLevel() || 1,
            $next = $(this).next(branchSelector);

          while ($next.length && $next.getBranchLevel() > level) {
            $descendants = $descendants.add($next);
            $next = $next.next(branchSelector);
          }
        });

        return $descendants;
      },
      nextBranch() {
        return $(this).next();
      },
      prevBranch() {
        return $(this).prev();
      },
      nextSibling() {
        const { branchSelector } = self.options;

        let level = $(this).getBranchLevel() || 1,
          $next = $(this).next(branchSelector),
          nextLevel = $next.getBranchLevel();

        while ($next.length && nextLevel > level) {
          $next = $next.next(branchSelector);
          nextLevel = $next.getBranchLevel();
        }

        return +nextLevel === +level ? $next : $();
      },
      prevSibling() {
        const { branchSelector } = self.options;
        let level = $(this).getBranchLevel() || 1,
          $prev = $(this).prev(branchSelector),
          prevLevel = $prev.getBranchLevel();

        while ($prev.length && prevLevel > level) {
          $prev = $prev.prev(branchSelector);
          prevLevel = $prev.getBranchLevel();
        }

        return prevLevel === level ? $prev : $();
      },
      getLastSibling() {
        let $nextSibling = $(this).nextSibling();

        if (!$nextSibling.length) {
          return $(this);
        }

        while ($nextSibling.length) {
          let $temp = $nextSibling.nextSibling();

          if ($temp.length) {
            $nextSibling = $temp;
          } else {
            return $nextSibling;
          }
        }
      },
      getSiblings(level = null) {
        const { treeSelector, branchSelector } = self.options;
        level = level || $(this).getBranchLevel();

        let $siblings = [],
          $branches = $(`${treeSelector} > ${branchSelector}`),
          $self = this;

        $branches.length &&
          $branches.each(function () {
            let branchLevel = $(this).getBranchLevel();

            if (+branchLevel === +level && $self[0] !== $(this)[0]) {
              $siblings.push($(this));
            }
          });

        return $siblings;
      },
      calculateSiblingDistances() {
        const { branchSelector, branchPathSelector } = self.options;

        $(branchSelector).each(function () {
          const level = $(this).getBranchLevel() || 1;
          $(this).find(branchPathSelector).show();

          if (typeof $(this).nextSibling !== "function") return;
          if ($(this).hasClass("hidden")) return;

          if (level > 1) {
            const $sibling = $(this).nextSibling().not(".hidden");
            /**
             * If next sibling (siblings with same branch level) exists then
             * calculate the distance between two siblings and set the path
             * height according to the distance.
             */

            if ($sibling.length) {
              const distance = getDistance($(this).get(0), $sibling.get(0));

              const thisParent = $(this).getParent() || $(this).getRootChild();

              const parentDistance = getDistance($(this).get(0), thisParent.get(0));
              $sibling.find(branchPathSelector).css("height", `${Math.max(distance.distanceY + 8, 35)}px`);
              $(this)
                .find(branchPathSelector)
                .css("height", `${Math.max(parentDistance.distanceY + 8, 35)}px`);
            } else {
              /**
               * If no sibling exists to a branch then find the child.
               * If child exists then set the child height as the default 55px.
               */
              const $nextBranch = $(this).next(branchSelector);
              const nextBranchLevel = $nextBranch.getBranchLevel() || 1;

              const isChild = $nextBranch.length > 0 && nextBranchLevel > level;

              if (isChild) {
                $nextBranch.find(branchPathSelector).css("height", "35px");
              }

              if ($nextBranch.length > 0 && nextBranchLevel < level) {
                if ($(this).prevBranch().getBranchLevel() <= level) {
                  $(this).find(branchPathSelector).css("height", "35px");
                }
              }

              if ($(this).prevBranch().getBranchLevel() < level) {
                $(this).find(branchPathSelector).css("height", "35px");
              }
            }
          } else {
            $(this).find(branchPathSelector).hide();
          }
        });
      },
    });
  };

  this.addChildBranch = async function ($triggerElement, simulation = false) {
    console.log("addChildBranch", $triggerElement, simulation);
    const {
      treeSelector,
      branchSelector,
      dataAttributes: { id },
      maxLevel,
    } = self.options;

    const $branch = $triggerElement.closest(`${treeSelector} ${branchSelector}`);

    if (!$branch.length) {
      throw Error("Invalid selector! Make sure that your add child button is inside a branch.");
    }

    const existingIds = new Set(); // Assuming you have a set of existing IDs
    $(`${treeSelector} ${branchSelector}`).each(function () {
      existingIds.add($(this).text().trim());
    });

    let uid;
    do {
      uid = self.generateUUID(); // Generate a new UUID
    } while (existingIds.has("Sheet " + uid)); // Keep generating until the ID is unique

    const parent_id = $branch.data(id);

    const level = Math.min(maxLevel, parseInt($branch.getBranchLevel()) + 1);

    const name = "Sheet " + uid;

    const $lastChild = $branch.getLastChild();

    //const item = data.find((item) => item.id === parent_id);
    //console.log(item); // Log the found item
    //console.log(item?.tabColor);

    let newId = 0;

    const obj = {
      id: newId,
      parent_id: parent_id.toString(),
      level: level.toString(),
      name: name,
      position: -1,
    };

    let $element;

    if ($lastChild.length) {
      obj.position = $lastChild.index();
    } else {
      obj.position = $branch.index();
    }

    let props;

    if (!simulation) {
      props = await createWorksheet(
        name,
        { id: "0", parent_id, name, level, position: obj.position + 1 },
        getWorkbookMeta().find((item) => item.id === parent_id)?.tabColor || ""
      );

      $element = self.createBranch(
        {
          ...obj,
          id: props.id,
          name: props.name,
          tabColor: getWorkbookMeta().find((item) => item.id === parent_id)?.tabColor || "",
        },
        undefined,
        3
      );

      if ($lastChild.length) {
        $lastChild.after($element);
      } else {
        $branch.after($element);
      }

      $(treeSelector).calculateSiblingDistances();
      self.updateBranchZIndex();
      self.branchesLeftShifting();

      return props.id;
    }
    /*
    if ($lastChild.length) {
      $lastChild.after($element);
    } else {
      $branch.after($element);
    }
    */
    return obj;
  };

  this.addSiblingBranch = async function ($triggerElement, simulation = false, id) {
    console.log("addSiblingBranch", $triggerElement, simulation);
    const {
      treeSelector,
      branchSelector,
      dataAttributes: { parent },
    } = self.options;

    const $branch = $triggerElement.closest(`${treeSelector} ${branchSelector}`);

    const existingIds = new Set(); // Assuming you have a set of existing IDs
    $(`${treeSelector} ${branchSelector}`).each(function () {
      existingIds.add($(this).text().trim());
    });

    let uid;
    do {
      uid = self.generateUUID(); // Generate a new UUID
    } while (existingIds.has("Sheet " + uid)); // Keep generating until the ID is unique
    console.log("branch", $branch);
    console.log("branch", $branch.data(parent));
    const parent_id = $branch.data(parent);
    const level = $branch.getBranchLevel();
    const name = "Sheet " + uid;
    const $lastSibling = $branch.getLastSibling();
    let $lastChild = $lastSibling.getLastChild();

    while ($lastChild.length) {
      let $temp = $lastChild.getLastChild();

      if ($temp.length) {
        $lastChild = $temp;
      } else {
        break;
      }
    }

    let newId = 0;

    const obj = {
      id: newId,
      parent_id: parent_id.toString(),
      level: level.toString(),
      name: name,
      position: -1,
    };

    let $element;

    if ($lastChild.length) {
      obj.position = $lastChild.index();
    } else {
      obj.position = $lastSibling.index();
    }

    let props;

    if (!simulation) {
      console.log("b4");
      props = await createWorksheet(name, {
        id: "0",
        parent_id,
        name,
        level,
        position: obj.position + 1,
      });
      $element = self.createBranch({ ...obj, id: props.id, name: props.name }, undefined, 4);

      if ($lastChild.length) {
        $lastChild.after($element);
      } else {
        $lastSibling.after($element);
      }

      $(treeSelector).calculateSiblingDistances();
      self.updateBranchZIndex();
      self.branchesLeftShifting();

      return props.id;
    }

    if (simulation == 1) {
      $element = self.createBranch({ ...obj, id: id }, undefined, 5);
      if ($lastChild.length) {
        $lastChild.after($element);
      } else {
        $lastSibling.after($element);
      }
      $(treeSelector).calculateSiblingDistances();
      self.updateBranchZIndex();
      self.branchesLeftShifting();
      return { ...obj, id };
    }

    /*
    if ($lastChild.length) {
      $lastChild.after($element);
      obj.position = $lastChild.index();
    } else {
      $lastSibling.after($element);
      obj.position = $lastSibling.index();
    }
    */
    return obj;
  };

  this.removeBranch = async function ($triggerElement, type) {
    console.log("removeBranch", $triggerElement);
    const { treeSelector, branchSelector } = self.options;

    const $branch = $triggerElement.closest(`${treeSelector} ${branchSelector}`);
    console.log("branch", $branch);

    if ($branch.length == 0) {
      console.log("already deleteMetadata, returning");
      return;
    }

    if ($branch.closest("ul").find(">li").length == 1) {
      console.log("This is the last worksheet.. returning..");
      return;
    }

    const branchId = $branch[0].getAttribute("data-id");
    const branchIndex = $branch.index();
    const $descendants = $($branch.getDescendants().get().reverse());

    // Convert jQuery collection to an array for sequential processing
    const descendantElements = Array.from($descendants);

    if (!type) {
      for (const element of descendantElements) {
        const worksheetId = element.getAttribute("data-id");
        const isEmpty = await isWorksheetEmpty(worksheetId);

        if (!isEmpty) {
          /*
          const dialogResult = await openDialog(
            "Microsoft Excel will permanently delete this sheet. Do you want to continue?",
            "Delete",
            "Cancel"
          );
          if (dialogResult === "CANCEL") {
            return; // Stop deletion if user cancels
          }*/
          document.getElementById("modalBtn1").addEventListener("click", () => resolveMessage(true));
          document.getElementById("modalBtn2").addEventListener("click", () => resolveMessage(false));
          const response = await showMessage("Are you sure?", "OK", "Cancel");

          console.log("User response:", response);

          if (!response) {
            return; // If user clicks "Cancel", stop execution
          }
        }

        await deleteWorksheetById(worksheetId);
        $(element).remove();
      }
    }

    // Now delete the parent branch
    if ($("#tree > li").length > 1) {
      if (!type) {
        if (!(await isWorksheetEmpty(branchId))) {
          /*
          const dialogResult = await openDialog(
            "Microsoft Excel will permanently delete this sheet. Do you want to continue?",
            "Delete",
            "Cancel"
          );
          if (dialogResult === "CANCEL") {
            return; // Stop deletion if user cancels
          }*/
          document.getElementById("modalBtn1").addEventListener("click", () => resolveMessage(true));
          document.getElementById("modalBtn2").addEventListener("click", () => resolveMessage(false));
          const response = await showMessage("Are you sure?", "OK", "Cancel");

          console.log("User response:", response);

          if (!response) {
            return; // If user clicks "Cancel", stop execution
          }
        }
      }
      if (!type) {
        await deleteWorksheetById(branchId);
      }
      $branch.remove();

      // Update tree structure after deletion
      self.updateBranchZIndex();
      self.branchesLeftShifting();
      $(treeSelector).calculateSiblingDistances();

      return branchIndex;
    }
  };

  this.updateBranchZIndex = function () {
    const { treeSelector, branchSelector } = self.options;
    const $branches = $(`${treeSelector} > ${branchSelector}`);
    const length = $branches.length;

    $branches.length &&
      $branches.each(function (index) {
        $(this).css("z-index", Math.max(1, length - index));
      });
  };

  this.initSorting = function (disabled) {
    console.log("settings disabled", disabled);
    const {
      treeSelector,
      dragHandlerSelector,
      placeholderName,
      childrenBusSelector,
      branchPathSelector,
      branchSelector,
      levelPrefix,
      dataAttributes,
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      maxLevel,
    } = self.options;

    self.updateBranchZIndex();

    /** Store the current level, for sorting the item after stop dragging. */
    let currentLevel = 1,
      originalLevel = 1,
      childrenBus = null,
      helperHeight = 0,
      originalIndex = 0;

    /** Render the branch paths initially. */
    $(self.options.treeSelector).calculateSiblingDistances();

    /** Update the placeholder branch level by new level. */
    const updatePlaceholder = (placeholder, level) => {
      placeholder.updateBranchLevel(level);
      currentLevel = level;
    };

    /** Check if we can swap items vertically for branch with children */
    const canSwapItems = (ui) => {
      let offset = ui.helper.offset(),
        height = offset.top + helperHeight,
        nextBranch = ui.placeholder.nextBranch(),
        nextBranchOffset = nextBranch.offset() || 0,
        nextBranchHeight = nextBranch.outerHeight();

      return height > nextBranchOffset.top + nextBranchHeight / 3;
    };

    $(treeSelector).sortable({
      handle: dragHandlerSelector,
      placeholder: placeholderName,
      items: "> *",
      disabled: disabled,
      start(_, ui) {
        /** Synchronize the placeholder level with the item's level. */
        const level = ui.item.getBranchLevel();
        ui.placeholder.updateBranchLevel(level);
        originalIndex = ui.item.index();

        /**  Store the original level. */
        originalLevel = level;

        /** Fill the children bus with the children. */
        childrenBus = ui.item.find(childrenBusSelector);
        childrenBus.append(ui.item.next().getDescendants());

        /**
         * Calculate the placeholder width & height according to the
         * helper's width & height respectively.
         */
        let height = childrenBus.outerHeight();
        let placeholderMarginTop = ui.placeholder.css("margin-top");

        height += height > 0 ? self.pxToNumber(placeholderMarginTop) : 0;
        height += ui.helper.outerHeight();
        helperHeight = height;
        height -= 2;

        let width = ui.helper.find(branchSelector).outerWidth() - 2;
        ui.placeholder.css({ height, width });

        const tmp = ui.placeholder.nextBranch();
        tmp.css("margin-top", self.numberToPx(helperHeight));
        ui.placeholder.detach();
        $(this).sortable("refresh");
        ui.item.after(ui.placeholder);
        tmp.css("margin-top", 0);

        // Set the current level by the initial item's level.
        currentLevel = level;
        $(`${treeSelector} ${branchSelector} ${branchPathSelector}`).hide();
      },
      sort(_, ui) {
        const { depth, maxLevel } = self.options;
        let treeEdge = self.getTreeEdge(),
          offset = ui.helper.offset(),
          currentBranchEdge = offset.left,
          lowerBound = 1,
          upperBound = maxLevel;

        /**
         * Calculate the upper bound. The upper bound would be,
         * the minimum value between the
         * (previous branch level + 1) and the maxLevel.
         */
        let prevBranch = ui.placeholder.prevBranch();
        prevBranch = prevBranch[0] === ui.item[0] ? prevBranch.prevBranch() : prevBranch;

        let prevBranchLevel = prevBranch.getBranchLevel();
        upperBound = Math.min(prevBranchLevel + 1, maxLevel);

        /**
         * Calculate the lower bound. The lower bound would be,
         * the maximum value between the
         * Next Sibling Level and 1
         */
        let nextSibling = ui.placeholder.nextSibling(),
          placeholderLevel = 1;

        if (nextSibling.length) {
          placeholderLevel = ui.placeholder.getBranchLevel() || 1;
        } else {
          /**
           * If no sibling found then
           * the placeholder level would be the next branch's level.
           */
          let nextBranch = ui.placeholder.nextBranch();
          placeholderLevel = nextBranch.getBranchLevel() || 1;
        }

        lowerBound = Math.max(1, placeholderLevel);

        /**
         * Calculate the position which is the current helper offset left
         * minus the tree parent's offset left.
         * Find the changed level by dividing the position by depth value.
         *
         * The final valid changed level would be a value
         * between upper and lower bound inclusive.
         */
        let position = Math.max(0, currentBranchEdge - treeEdge);
        let newLevel = Math.floor(position / depth) + 1;
        newLevel = Math.max(lowerBound, Math.min(newLevel, upperBound));

        if (canSwapItems(ui)) {
          let nextBranch = ui.placeholder.nextBranch();

          if (nextBranch.getDescendants().length) {
            newLevel = nextBranch.getBranchLevel() + 1;
          }

          nextBranch.after(ui.placeholder);
          $(this).sortable("refreshPositions");
        }

        /** Update the placeholder position by the changed level. */
        updatePlaceholder(ui.placeholder, newLevel);
      },
      change(_, ui) {
        let prevBranch = ui.placeholder.prevBranch();

        prevBranch = prevBranch[0] === ui.item[0] ? prevBranch.prevBranch() : prevBranch;

        /**
         * After changing branches bound the placeholder to the
         * changed boundary.
         */
        let prevBranchLevel = prevBranch.getBranchLevel() || 1;

        if (prevBranch.length) {
          ui.placeholder.detach();
          let children = prevBranch.getDescendants();
          // eslint-disable-next-line office-addins/call-sync-before-read
          if (children && children.length) prevBranchLevel += 1;
          ui.placeholder.updateBranchLevel(prevBranchLevel);
          prevBranch.after(ui.placeholder);
        }
      },
      stop(_, ui) {
        $(`${branchSelector}:not(${levelPrefix}-1) ${branchPathSelector}`).show();

        /**
         * Place the children after the sorted item,
         * and clear the children bus.
         */
        const children = childrenBus.children().insertAfter(ui.item);

        childrenBus.empty();

        /** Update the item by currently changed level. */
        ui.item.updateBranchLevel(currentLevel);
        children.shiftBranchLevel(currentLevel - originalLevel, ui.item.attr("data-id"));

        //taskQueue.add(async function () {
        //  await trackWorksheetPositions("save", ui.item.index());
        //}, "Save workbookmeta after changing tab order in tree");

        // Calculate the sibling distance affter sorting
        $(this).calculateSiblingDistances();
        self.updateBranchZIndex();

        /** Update the parent ID after sorting. */
        const $parent = ui.item.getParent();

        console.log(ui.item.index());
        console.log($parent.index());

        let jump = false;
        if (Math.abs(ui.item.index() - $parent.index()) > 1 && $parent.index() > -1) {
          jump = true;
        }

        let parent_id = $parent.data(dataAttributes.id);
        if (typeof parent_id == "undefined") parent_id = "0";
        ui.item.data(dataAttributes.parent, parent_id).attr(`data-${dataAttributes.parent}`, parent_id);

        $(treeSelector)
          .find(branchSelector)
          .each(function (index) {
            $(this).attr("data-position", index);
          });

        /**
         * Trigger `sortCompleted` event if the level changed or index changed.
         * i.e. if the items sorted then trigger the event.
         */
        if (currentLevel !== originalLevel || originalIndex !== ui.item.index()) {
          $(treeSelector).trigger("sortCompleted", [ui, ui.item, ui.item.getDescendants(), "tree", jump]);
        }
      },
    });
  };
}
